enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  REGISTER_WITH_ROBOT = "registerWithRobot",
  REGISTER_WITH_STUDIO_ROBOT = "registerWithStudioRobot",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  CHANGE_LANGUAGE = "changeLanguage",
  HANDLE_COLLECTION_RESULT = "handleCollectionResult",
  CLEAR_TABLE_DATA = "clearTableData",
  REFRESH_TABLE_DATA = "refreshTableData",
  FETCH_COMPANY_LIST = "fetchCompanyList",

  INIT_DASHBOARD_STATISTICS = "initDashboardStatistics",
  SET_DASHBOARD_DATA = "setDashboardData",
  SET_JOB_STATISTICS = "setJobStatistics",
  SET_PACKAGE_STATISTICS = "setPackageStatistics",
  SET_MACHINE_STATISTICS = "setMachineStatistics",
  SET_ROBOT_STATUS_STATISTICS = "setRobotStatusStatistics",
  SET_ROBOT_TYPE_STATISTICS = "setRobotTypeStatistics",
  START_INTERVAL = "startInterval",

  SET_SEARCH_RESULT_AGENT = "setSearchResultAgent",
  SET_SEARCH_RESULT_IDENTITY = "setSearchResultIdentity",
  SET_SEARCH_RESULT_ORCH = "setSearchResultOrch",
  SET_SEARCH_RESULT_CUSTOMER = "setSearchResultCustomer",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_TOKEN = "setToken",
  SET_USER = "setUser",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_LANGUAGE = "setLanguage",
  SET_ID = "setId",
  SET_DATA_TYPE = "setDataType",
  SET_PERCENTAGE = "setPercentage",
  SET_TIMEOUT = "setTimeout",
  SET_INTERVAL_VALUE = "setIntervalValue",
  CLEAR_INTERVAL_VALUE = "clearIntervalValue",

  //TABLE
  SET_PAGE = "setPage",
  SET_FETCH_DATA = "setFetchData",
  SET_EXPORT_DATA = "setExportData",
  SET_PAGE_SIZE = "setPageSize",
  SET_TOTAL_DATA_COUNT = "setTotalDataCount",
  SET_TABLE_ERROR = "setTableError",
  SET_TABLE_DATA = "setTableData",
  SET_TABLE_DATA_TYPE = "setTableDataType",
  SET_BLOCK_HARD_CLEAR = "setBlockHardClear",
  SET_TABLE_LOADING = "setTableLoading",
  SET_COMPANIES = "setCompanies",

  //DASHBOARD STATISTICS START
  SET_IS_DASHBOARD = "setIsDashboard",
  SET_DASHBOARD_DATA_FETCHED = "setDashboardDataFetched",

  //JOB START
  SET_FAULTED_JOB_COUNT = "setFaultedJobCount",
  SET_PENDING_JOB_COUNT = "setPendingJobCount",
  SET_RETRIED_JOB_COUNT = "setRetriedJobCount",
  SET_RUNNING_JOB_COUNT = "setRunningJobCount",
  SET_STOPPED_JOB_COUNT = "setStoppedJobCount",
  SET_SUCCESSFULL_JOB_COUNT = "setSuccessfulJobCount",
  //JOB END

  //PROCESS START
  SET_PROCESS_PACKAGE_COUNT = "setProcessPackageCount",
  SET_LIBRARY_PACKAGE_COUNT = "setLibraryPackageCount",
  //PROCESS END

  //MACHINE START
  SET_MACHINE_COUNT = "setMachineCount",
  //MACHINE END

  //ROBOT STATUS START
  SET_ONLINE_ROBOT_COUNT = "setOnlineRobotCount",
  SET_BUSY_ROBOT_COUNT = "setBusyRobotCount",
  SET_UNRESPONSIVE_ROBOT_COUNT = "setUnresponsiveRobotCount",
  //ROBOT STATUS START

  //ROBOT TYPE START
  SET_STUDIO_ROBOT_COUNT = "setStudioRobotCount",
  SET_UNATTENDED_ROBOT_COUNT = "setUnattendedRobotCount",
  //ROBOT TYPE START

  //DASHBOARD STATISTICS END

  // SEARCH RESULTS START
  SET_SEARCH_TERM = "setSearchTerm",
  // AGENT START
  SET_PROCESS_SEARCH_RESULT = "setProcessSearchResult",
  SET_PACKAGE_SEARCH_RESULT = "setPackageSearchResult",
  SET_TRIGGER_SEARCH_RESULT = "setTriggerSearchResult",
  SET_QUEUE_SEARCH_RESULT = "setQueueSearchResult",
  SET_ASSET_SEARCH_RESULT = "setAssetSearchResult",
  SET_CREDENTIAL_SEARCH_RESULT = "setCredentialSearchResult",

  // AGENT END

  // ORCH START
  SET_ROBOT_SEARCH_RESULT = "setRobotSearchResult",
  // ORCH END

  // IDENTITY START
  SET_USER_SEARCH_RESULT = "setUserSearchResult",
  // IDENTITY END

  // CUSTOMER START
  SET_MACHINE_SEARCH_RESULT = "setMachineSearchResult",
  // CUSTOMER END
  // SEARCH RESULTS END
}

export { Actions, Mutations };
